import React, { useEffect, useState } from 'react'
import './track.css'
import {
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TextField,
  TableSortLabel,
  TablePagination,
  Button,
  Select,
  MenuItem
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import TrackingBody from './TableBody'
import { getExecutiveCases, selectTeamTracking, selectTrackingLoader } from '@views/tracking/state/trackingSlice2'
import { TrackingRows } from '@types'
import { formatPesos } from '../../utils/format'

export type Order = 'asc' | 'desc'

const ReferralsView: React.FC = () => {
  const rows: TrackingRows[] = useSelector(selectTeamTracking)
  const isLoading = useSelector(selectTrackingLoader)
  const [order, setOrder] = useState<Order>('desc')
  const [isNumeric, setIsNumeric] = useState(false)
  const [isDateSort, setIsDateSort] = useState(true)
  const [orderBy, setOrderBy] = useState<string>('createdAt')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const dispatch = useDispatch()
  const [searchName, setSearchName] = useState('')
  const [searchParent, setSearchParent] = useState('')
  const [searchStage, setSearchStage] = useState<'studyDate' | 'office' | 'bank' | 'success'>('office')
  const [searchStageKey, setSearchStageKey] = useState('')

  const createSortHandler = (property: string, isNumeric: boolean) => () => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
    setIsNumeric(isNumeric)
    setIsDateSort(property === 'studyDate')
  }

  useEffect(() => {
    dispatch(getExecutiveCases())
    setPage(0)
    setRowsPerPage(10)
  }, [])

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const onChangeStageSearch = (value: string) => {
    setSearchStageKey(value)
  }
  const filteredRows = rows.filter(user => {
    return (
      user.parent?.name
        ?.toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          searchParent
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
        ) &&
      user.name
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          searchName
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
        ) &&
      user[searchStage]
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(
          searchStageKey
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
        )
    )
  })

  const totalFeeNumber = filteredRows.reduce((a, b) => a + (b.isRejected ? 0 : Number(b.fee)), 0)
  const totalFee = formatPesos(totalFeeNumber)
  const totalFeeNoIva = formatPesos(Math.ceil(totalFeeNumber / 1.19))

  const handleClear = () => {
    setSearchStageKey('')
    setSearchStage('studyDate')
    setOrderBy('createdAt')
    setOrder('desc')
    setPage(0)
    dispatch(getExecutiveCases())
  }
  return (
    <>
      <div className="center_view padding_view">
        <TableContainer className="container-table" component={Paper}>
          <div className="table-container-search">
            <TextField
              id="outlined-multiline-flexible"
              label="Ahorrador"
              value={searchName}
              onChange={event => setSearchName(event.target.value)}
              variant="outlined"
              className="input-search"
            />
            <TextField
              id="outlined-multiline-flexible"
              label="Referenciador"
              value={searchParent}
              onChange={event => setSearchParent(event.target.value)}
              variant="outlined"
              className="input-search"
            />
            <Box>
              <Select
                variant="outlined"
                required
                value={searchStage}
                onChange={e => setSearchStage(e.target.value as 'studyDate' | 'office' | 'bank' | 'success')}
              >
                <MenuItem value="office">Oficina</MenuItem>
                <MenuItem value="studyDate">Estudio</MenuItem>
                <MenuItem value="bank">Radicado</MenuItem>
                <MenuItem value="success">Exitoso</MenuItem>
              </Select>
              <TextField
                id="outlined-multiline-flexible"
                label="Fecha"
                placeholder="AAAA/MM/DD"
                value={searchStageKey}
                onChange={event => onChangeStageSearch(event.target.value)}
                variant="outlined"
                className="input-search"
              />
            </Box>
            <Button type="submit" variant="contained" color="primary" onClick={handleClear}>
              Limpiar
            </Button>
          </div>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  className="table_header"
                  style={{ color: 'white' }}
                  align="left"
                  sortDirection={orderBy === 'progress' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'name'}
                    direction={orderBy === 'name' ? order : 'asc'}
                    onClick={createSortHandler('name', false)}
                  >
                    AHORRADOR
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  className="table_header"
                  style={{ color: 'white' }}
                  align="left"
                  sortDirection={orderBy === 'bankName' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'bankName'}
                    direction={orderBy === 'bankName' ? order : 'asc'}
                    onClick={createSortHandler('bankName', false)}
                    style={{ color: 'white' }}
                  >
                    BANCO
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  className="table_header"
                  style={{ color: 'white' }}
                  align="center"
                  sortDirection={orderBy === 'studyDate' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'studyDate'}
                    direction={orderBy === 'studyDate' ? order : 'asc'}
                    onClick={createSortHandler('studyDate', false)}
                  >
                    ESTUDIO
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  className="table_header"
                  style={{ color: 'white' }}
                  align="center"
                  sortDirection={orderBy === 'office' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'office'}
                    direction={orderBy === 'office' ? order : 'asc'}
                    onClick={createSortHandler('office', false)}
                  >
                    OFICINA
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  className="table_header"
                  style={{ color: 'white' }}
                  align="center"
                  sortDirection={orderBy === 'bank' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'bank'}
                    direction={orderBy === 'bank' ? order : 'asc'}
                    onClick={createSortHandler('bank', false)}
                  >
                    RADICADO
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  className="table_header"
                  style={{ color: 'white' }}
                  align="center"
                  sortDirection={orderBy === 'success' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'success'}
                    direction={orderBy === 'success' ? order : 'asc'}
                    onClick={createSortHandler('success', false)}
                  >
                    EXITOSO
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  className="table_header"
                  style={{ color: 'white' }}
                  align="center"
                  sortDirection={orderBy === 'fee' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'fee'}
                    direction={orderBy === 'fee' ? order : 'asc'}
                    onClick={createSortHandler('fee', true)}
                  >
                    HONORARIOS
                  </TableSortLabel>
                </TableCell>
                <TableCell
                  className="table_header"
                  style={{ color: 'white' }}
                  align="center"
                  sortDirection={orderBy === 'payments' ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === 'payments'}
                    direction={orderBy === 'payments' ? order : 'asc'}
                    onClick={createSortHandler('payments', true)}
                  >
                    HONORARIOS SIN IVA
                  </TableSortLabel>
                </TableCell>

                <TableCell className="table_header" style={{ color: 'white' }} align="center"></TableCell>
              </TableRow>
            </TableHead>
            <TrackingBody
              users={filteredRows}
              rowsPerPage={rowsPerPage}
              order={order}
              page={page}
              isNumeric={isNumeric}
              isDateSort={isDateSort}
              orderBy={orderBy}
              isLoading={!!isLoading}
              isTeam={true}
            />
          </Table>
          <div className="pagination-row">
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={
                rows.filter(user => {
                  return (
                    user.parent?.name
                      ?.toLowerCase()
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .includes(
                        searchParent
                          .toLowerCase()
                          .normalize('NFD')
                          .replace(/[\u0300-\u036f]/g, '')
                      ) &&
                    user.name
                      .toLowerCase()
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .includes(
                        searchName
                          .toLowerCase()
                          .normalize('NFD')
                          .replace(/[\u0300-\u036f]/g, '')
                      ) &&
                    user[searchStage]
                      .toLowerCase()
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .includes(
                        searchStageKey
                          .toLowerCase()
                          .normalize('NFD')
                          .replace(/[\u0300-\u036f]/g, '')
                      )
                  )
                }).length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <div>Total Honorarios: ${totalFee}</div>
            <div>Total Honorarios Sin IVA: ${totalFeeNoIva}</div>
          </div>
        </TableContainer>
      </div>
    </>
  )
}

export default ReferralsView
